export default __webpack_public_path__ + "static/Propellant-65dbe29bb1a849cdf8bce77c27c57888.png";